/* eslint-disable */
import * as Types from './types';

import { ModuleBlogHeroFragmentDoc, ModuleBlogHeroImageFragmentDoc } from './ModuleBlogHero';
import { ImageFragmentDoc } from './Image';
import { BlogNavFragmentDoc } from './ModuleBlogNavigation';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type GetBlogCategoryQueryVariables = Types.Exact<{
  handle: Types.Scalars['String'];
  locale?: Types.InputMaybe<Types.Scalars['String']>;
  preview?: Types.InputMaybe<Types.Scalars['Boolean']>;
  tagFilter?: Types.InputMaybe<Types.BlogCategoryFilter>;
}>;


export type GetBlogCategoryQuery = { __typename?: 'Query', blogCategory?: { __typename?: 'BlogCategoryCollection', data: Array<{ __typename?: 'BlogCategory', seoTitle?: string | null, seoDescription?: string | null, handle?: string | null, category?: string | null, hero?: { __typename: 'ModuleBlogHero', proContent?: boolean | null, slidesCollection?: { __typename?: 'ModuleBlogHeroSlidesCollection', items: Array<{ __typename?: 'ModuleBlogHeroSlide', title?: string | null, subtitle?: string | null, description?: string | null, buttonLabel?: string | null, buttonLink?: string | null, openLinkInNewTab?: boolean | null, featuredImage?: { __typename?: 'ModuleBlogHeroImage', mobile?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, desktop?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null, imagesCollection?: { __typename?: 'ModuleBlogHeroSlideImagesCollection', items: Array<{ __typename?: 'ModuleBlogHeroImage', mobile?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, desktop?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null } | null> } | null } | null, navigation?: { __typename: 'BlogNav', heading?: string | null, blogNavItemsCollection?: { __typename?: 'BlogNavBlogNavItemsCollection', items: Array<{ __typename?: 'BlogNavItem', title?: string | null, path?: string | null, openLinkInNewTab?: boolean | null, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null } | null } | null> } | null };

export declare const getBlogCategory: import("graphql").DocumentNode;

export const GetBlogCategoryDocument = /*#__PURE__*/ `
    query getBlogCategory($handle: String!, $locale: String = "en-US", $preview: Boolean = false, $tagFilter: BlogCategoryFilter) {
  blogCategory: blogCategoryCollection(
    limit: 1
    locale: $locale
    preview: $preview
    where: {AND: [{handle: $handle}, $tagFilter], sys: {id_exists: true}}
  ) {
    data: items {
      seoTitle
      seoDescription
      handle
      category
      hero {
        ...ModuleBlogHeroFragment
      }
      navigation {
        ...BlogNavFragment
      }
    }
  }
}
    ${ModuleBlogHeroFragmentDoc}
${ModuleBlogHeroImageFragmentDoc}
${ImageFragmentDoc}
${BlogNavFragmentDoc}`;
export const useGetBlogCategoryQuery = <
      TData = GetBlogCategoryQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetBlogCategoryQueryVariables,
      options?: UseQueryOptions<GetBlogCategoryQuery, TError, TData>
    ) =>
    useQuery<GetBlogCategoryQuery, TError, TData>(
      ['getBlogCategory', variables],
      fetcher<GetBlogCategoryQuery, GetBlogCategoryQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetBlogCategoryDocument, variables, options),
      options
    );

useGetBlogCategoryQuery.getKey = (variables: GetBlogCategoryQueryVariables) => ['getBlogCategory', variables];
;

useGetBlogCategoryQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: GetBlogCategoryQueryVariables, options?: RequestInit['headers']) => fetcher<GetBlogCategoryQuery, GetBlogCategoryQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetBlogCategoryDocument, variables, options);